function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from "./Button";
import { defaultIconStyles } from "./defaultButtonIconStyles";
export function EditButton(_ref) {
  let {
    iconStyles,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle me-2"
  }, props), /*#__PURE__*/React.createElement("span", {
    style: iconStyles || defaultIconStyles,
    className: "material-icons md-18 text-info rounded-circle mx-auto"
  }, "edit"));
}